import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Label from '../Elements/Label';
import CustomIcon from '../Elements/CustomIcon';
import Select from '../Elements/Select';

import Span from '../Elements/Span';

import { Context } from '../Wizard/WizardWrapper';
import { ELECTION_TYPE } from '../../../../utils/constants';

const StateTerritories = ({ item }) => {
  const { watch, errors, fieldsValidated } = useContext(Context);
  const electionTypeId = parseInt(watch('electionTypeId'));

  if (
    typeof electionTypeId === 'number' &&
    (electionTypeId === ELECTION_TYPE.ORDINARY ||
      electionTypeId === ELECTION_TYPE.SPECIAL_ELECTION)
  ) {
    return (
      <React.Fragment key={`gender-select-${item}`}>
        <div className="col-lg-6 mt-5">
          <div className="form-group">
            <Label
              className="mb-3"
              label={item.label}
              name={item.name}
              errors={errors}
              required={item.required}
            />
            <CustomIcon
              fieldsValidated={fieldsValidated}
              fieldError={errors[item.name]}
              required={item.required}
            />
            <Select options="state-territories" name={item.name} />

            <Span text={errors[item.name] ? errors[item.name].message : ''} />
          </div>
        </div>
      </React.Fragment>
    );
  }

  return null;
};

StateTerritories.propTypes = {
  item: PropTypes.object.isRequired,
};

export default StateTerritories;
